import React from 'react';
import { useLeagueSelection } from '../../../../hooks/useLeagueSelection';
import './Legende.css';

const TableLegende = () => {
    const {leagueLevel} = useLeagueSelection();

    return (
        <div className="tabellen-schluessel">
            <h1>TABELLEN SCHLÜSSEL</h1>
            <div className="content-box">
                <div className="section">
                    <h2>MEISTERSCHAFT/RELEGATION</h2>
                    <div className="key-item">
                        <div className="color-indicator green"></div>
                        <div className="label">{leagueLevel === '1' ? "Finale" : leagueLevel === '2' ? "Aufstieg Halbfinale":""}</div>
                    </div>
                    {leagueLevel === '1' ?
                        ( <div className="key-item">
                            <div className="color-indicator orange"></div>
                            <div className="label">Relegation</div>
                        </div> )
                        : null}
                    <div className="key-item">
                        <div className="color-indicator red"></div>
                        <div className="label">Abstieg</div>
                    </div>
                </div>

                <div className="section">
                    <h2>LEGENDE</h2>
                    <div className="legend-grid">
                        <div className="legend-item">
                            <div className="legend-key">Sp</div>
                            <div className="legend-value">Spiele</div>
                        </div>
                        <div className="legend-item">
                            <div className="legend-key">S</div>
                            <div className="legend-value">Siege</div>
                        </div>
                        <div className="legend-item">
                            <div className="legend-key">U</div>
                            <div className="legend-value">Unentschieden</div>
                        </div>
                        <div className="legend-item">
                            <div className="legend-key">N</div>
                            <div className="legend-value">Niederlagen</div>
                        </div>
                        <div className="legend-item">
                            <div className="legend-key">Pkt</div>
                            <div className="legend-value">Punkte</div>
                        </div>

                        <div className="legend-item">
                            <div className="legend-key">D</div>
                            <div className="legend-value">Differenz</div>
                        </div>
                        <div className="legend-item">
                            <div className="legend-key">BP</div>
                            <div className="legend-value">Bonuspunkte</div>
                        </div>
                        <div className="legend-item">
                            <div className="legend-key">BV</div>
                            <div className="legend-value">Bonuspunkte Versuche</div>
                        </div>
                        <div className="legend-item">
                            <div className="legend-key">BN</div>
                            <div className="legend-value">Bonuspunkte Niederlage</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TableLegende;
